import React from 'react';

import { DestructiveModal } from '@capintel/component-lib/destructive-modal';
import { Stack } from '@capintel/component-lib/stack';

import GenericContact from '@/types/generic-contact';
import { formatMessage, FormattedMessage } from '@/utils/i18n';
import { getContactName } from '@/utils/contacts';

type Props = {
  contacts: GenericContact[];
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const DeleteContactsModal = ({ contacts, show, onConfirm, onCancel }: Props) => (
  <DestructiveModal
    open={show}
    onOpenChange={open => !open && onCancel()}
    title={formatMessage('Contacts.DeleteModal.Title', { count: contacts.length })}
    content={
      <Stack gap="150">
        <FormattedMessage id="Contacts.DeleteModal.Body" values={{ count: contacts.length }} />
        <ul data-private data-dd-privacy="mask">
          {contacts.map(c => (
            <li key={c._id}>{getContactName(c)}</li>
          ))}
        </ul>
        <FormattedMessage id="Contacts.DeleteModal.Confirmation" />
      </Stack>
    }
    confirmButtonText={formatMessage('Contacts.DeleteModal.ConfirmButton', { count: contacts.length })}
    cancelButtonText={formatMessage('Common.Cancel')}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default DeleteContactsModal;
